// extracted by mini-css-extract-plugin
export default {"App":"App_App__0YxW-","switch-wrapper":"App_switch-wrapper__4Nu4B"};